module.exports = __webpack_public_path__ + "img/openbank.e5bc005b.png";